// extracted by mini-css-extract-plugin
module.exports = {"base":"Label_base__N40eN","alignRight":"Label_alignRight__3QP9B","textOnly":"Label_textOnly__1CAV8"};